export const isObject = (obj) => typeof obj === 'object' && !Array.isArray(obj)
